<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore } from '../../../store';
import Quadro from './components/Quadro.vue';
import Calendario from './components/Calendario.vue';
import Contatos from './components/Contatos.vue';
import SeuProximoEvento from './components/SeuProximoEvento.vue';
import RecadoDaEquipe from './components/RecadoDaEquipe.vue';

const felixBagAuxStore = useFelixBagAuxStore();

const audio = document.createElement("audio")

onMounted(() => {
  felixBagAuxStore.pauseAfter(1000)

  felixBagAuxStore.muteVideo();
  audio.pause();
  audio.src = "https://overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/videobot/vivo/audios_parametrizados/Seu+Quadro+de+Avisos.mp3"
  audio.play();
  setTimeout(() => {
    audio.pause()
  }, [14500]);
});

const itemToOpen = ref(null)

const openContent = (item) => {
  itemToOpen.value = item.name
}

const items = [
  {
    name: 'quadro_de_avisos',
    title: "Quadro de avisos",
    viewed: false,
    icon: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/42a8e28d-c926-4c60-890e-854c411cd687.svg'
  },
  {
    name: 'calendario',
    title: "Calendário",
    viewed: false,
    icon: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/57ac9ee4-fa6c-40ec-887f-421c3f5b867a.svg'
  },
  {
    name: 'contatos',
    title: 'Contatos',
    viewed: false,
    icon: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/48db74b6-4d03-4ab8-beea-7ec9c75443fb.svg'
  },
  {
    name: 'seu_proximo_evento',
    title: 'Seu próximo evento',
    viewed: false,
    icon: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/10d4affa-0770-43f1-8fa5-7561f064e83d.svg'
  }
  // {
  //   name: 'recado_da_equipe',
  //   title: 'Recado da equipe',
  //   viewed: false,
  //   icon: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/10d4affa-0770-43f1-8fa5-7561f064e83d.svg'
  // }
]

</script>

<template>
  <div id="quadro-de-avisos">
    <div class="header">
      <div style="display: flex; flex-direction: column; align-items: start; width: 60%;">
        <v-btn
          @click="felixBagAuxStore.hideInteractive('quadro-de-avisos'); audio.pause(); felixBagAuxStore.unmuteVideo()"
          variant="text" color="inherit"><img
            src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
            alt=""></v-btn>
        <p class="submenu-title">Seu Quadro de Avisos</p>
      </div>


      <img style="width: 40%;"
        src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/f15c3c1c-8ec1-4dcc-9a71-6f80444797dc.svg"
        alt="">

    </div>

    <v-card variant="flat" class="mx-auto" max-width="300" style="margin-top: 5%;">
      <v-list>
        <v-list-item class="jb-save" :data-source="item.name" height="60px" @click="openContent(item)" v-for="(item, i) in items" :key="i" :value="item">
          <template v-slot:prepend>
            <div class="icon-wrapper">
              <img style="width: 15px;" :src="item.icon" alt="">
            </div>

            <v-list-item-title style="margin-left: 20px;" v-text="item.title"></v-list-item-title>
          </template>

          <template v-slot:append>
            <img style="width: 15px;"
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg"
              alt="">
          </template>
        </v-list-item>

      </v-list>
    </v-card>
  </div>

  <Quadro @close-item="itemToOpen = ''" v-if="itemToOpen == 'quadro_de_avisos'" />
  <Calendario @close-item="itemToOpen = ''" v-if="itemToOpen == 'calendario'" />
  <Contatos @close-item="itemToOpen = ''" v-if="itemToOpen == 'contatos'" />
  <SeuProximoEvento @close-item="itemToOpen = ''" v-if="itemToOpen == 'seu_proximo_evento'" />
  <RecadoDaEquipe @close-item="itemToOpen = ''" v-if="itemToOpen == 'recado_da_equipe'" />
</template>

<style scoped>
#quadro-de-avisos {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  z-index: 1;
}

.header {
  height: 25%;
  background-color: #BC4AFF;
  display: flex;
}

.submenu-title {
  color: white;
  margin-top: 15px;
  font-size: 20px;
  text-align: start;
  margin-left: 20%;
}

.icon-wrapper {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F6E7FF;
  border-radius: 50%;
}
</style>